export class Paymentterm {
    paymenttermid: number;
    paymentterms: string;
	noofday:number;
    createdby:number;
    active: number;
}